// MoEngage Custom Tracking - Starts

jQuery(document).ready(function() {
  
  jQuery('a.WD_track_home_slider_click').on('click', function(event) {
    var passlink = jQuery(this).attr('href');
    moEng_track('WD_track_home_slider_click', passlink);
  });

  jQuery('a.WD_track_header_useracc').on('click', function(event) {
    var passlink = jQuery(this).attr('href');
    moEng_track('WD_track_header_useracc', passlink);
  });

  jQuery('a.WD_track_forgot_pass').on('click', function(event) {
    var passlink = jQuery(this).attr('href');
    moEng_track('WD_track_forgot_pass', passlink);
  });
  
  jQuery(document).on('click', 'a.wd_track_plp_click', function(event) {
    var passlink = jQuery(this).attr('href');
    moEng_track('wd_track_plp_click', passlink);
  });

  jQuery(document).on('click', 'a.WD_track_home_product_view', function(event) {
    var passlink = jQuery(this).attr('href');
    moEng_track('WD_track_home_product_view', passlink);
  });

  jQuery(document).on('click', '.WD_track_home_product_add_to_cart', function(event) {
    var passlink = jQuery(this).data('product-url');
    moEng_track('WD_track_home_product_add_to_cart', passlink);
  });

  jQuery(document).on('click', '.WD_track_plp_addcart', function(event) {
    var passlink = jQuery(this).data('product-url');
    moEng_track('WD_track_plp_addcart', passlink);
  });

  jQuery(document).on('click', '.WD_track_pdp_add_to_cart', function(event) {
    var passlink = window.location.href;
    moEng_track('WD_track_pdp_add_to_cart', passlink);
  });
  
  jQuery('div.shopify-payment-button').on('click', function(event) {
    var clickedDiv = jQuery(this);
    var currentPageUrl = window.location.href;
    moEng_track('WD_track_pdp_buy_now', currentPageUrl);
  });

  jQuery(document).on('click', '.WD_track_wishlist_visit', function(event) {
    var passlink = window.location.href;
    moEng_track('WD_track_wishlist_visit', passlink);
  });

  jQuery(document).on('click', '.WD_track_cart_visit', function(event) {
    var passlink = jQuery(this).data('cart-url');
    moEng_track('WD_track_cart_visit', passlink);
  });

  var currentUrl = window.location.href;
  if(currentUrl.includes("/collections/")) {
    moEng_track('WD_track_plp_visit', currentUrl);
  }
  
});

function moEng_track( tracking_id, passurl ) {
  //event.preventDefault();
  //alert('Tracking ID: ' + tracking_id + '\nURL: ' + passurl);
  console.log("Mo Track - TRACK ID", tracking_id, "| URL --", passurl);
  
  window.addEventListener("MOE_LIFECYCLE",function(e){
    if(e.detail.name === "SDK_INITIALIZED"){
       Moengage.track_event( tracking_id, {
        "product_link_click": passurl
       });
     }
   });
  
}

// MoEngage Custom Tracking - ENDS